module.exports = __webpack_public_path__ + "937865ddbe3f578111eb395221678616.png";


//////////////////
// WEBPACK FOOTER
// ./src/Integrations/connections/icons/sharepointonline.png
// module id = 962
// module chunks = 0